/* eslint-disable */
import * as Types from '../../graphql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const DomainByIdDocument = gql`
    query DomainById($domainId: Int!) {
  domain(domainId: $domainId) {
    user {
      id
      email
    }
    id
    title
    urlType
    userAccesses {
      id
      accessType
      email
      user {
        id
        email
      }
    }
  }
}
    `;

/**
 * __useDomainByIdQuery__
 *
 * To run a query within a React component, call `useDomainByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useDomainByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDomainByIdQuery({
 *   variables: {
 *      domainId: // value for 'domainId'
 *   },
 * });
 */
export function useDomainByIdQuery(baseOptions: Apollo.QueryHookOptions<DomainByIdQuery, DomainByIdQueryVariables> & ({ variables: DomainByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DomainByIdQuery, DomainByIdQueryVariables>(DomainByIdDocument, options);
      }
export function useDomainByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DomainByIdQuery, DomainByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DomainByIdQuery, DomainByIdQueryVariables>(DomainByIdDocument, options);
        }
// @ts-ignore
export function useDomainByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DomainByIdQuery, DomainByIdQueryVariables>): Apollo.UseSuspenseQueryResult<DomainByIdQuery, DomainByIdQueryVariables>;
export function useDomainByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DomainByIdQuery, DomainByIdQueryVariables>): Apollo.UseSuspenseQueryResult<DomainByIdQuery | undefined, DomainByIdQueryVariables>;
export function useDomainByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DomainByIdQuery, DomainByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DomainByIdQuery, DomainByIdQueryVariables>(DomainByIdDocument, options);
        }
export type DomainByIdQueryHookResult = ReturnType<typeof useDomainByIdQuery>;
export type DomainByIdLazyQueryHookResult = ReturnType<typeof useDomainByIdLazyQuery>;
export type DomainByIdSuspenseQueryHookResult = ReturnType<typeof useDomainByIdSuspenseQuery>;
export type DomainByIdQueryResult = Apollo.QueryResult<DomainByIdQuery, DomainByIdQueryVariables>;
export type DomainByIdQueryVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
}>;


export type DomainByIdQuery = { __typename?: 'Query', domain: { __typename?: 'GraphDomain', id?: number | null, title?: string | null, urlType?: number | null, user?: { __typename?: 'User', id?: number | null, email?: string | null } | null, userAccesses: Array<{ __typename?: 'UserAccess', id?: number | null, accessType?: number | null, email?: string | null, user?: { __typename?: 'User', id?: number | null, email?: string | null } | null }> } };
